// export const GET_USER = 'GET_USER';
export const SET_USER = 'SET_USER';
export const CHANGE_COUNTRY = "CHANGE_COUNTRY";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const CHECK_PERMISSION_LOADED = "CHECK_PERMISSION_LOADED";
// export const GET_COUNTRY_ID = "GET_COUNTRY_ID";
// export const GET_USER_GROUP = "GET_USER_GROUP";